import { ALL_PERMISSIONS } from '@mm/constants/facebook-permissions';
import { ErrorReportingUtils } from '@mm/plugins';
import { getErrorJson } from '@mm/utils';
import { get } from 'lodash';
import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import ConnectedPageCRUDActions from '../actions/ConnectedPageCRUDActions';
import modalActions, {
  openConnectedPageErrorModal,
  openRefreshAccessTokenErrorModal,
} from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

const errorData = (response: Response) => {
  const data = get(response, 'errors[0]');

  if (data) {
    if (typeof data === 'string') {
      return { errorMessage: data };
    }

    return data;
  }
  return {
    errorMessage:
      'Error connecting your Facebook page. Please contact support.',
  };
};

export default (
    dispatch: Dispatch<StoreState>,
    errorStatusCodeToOpenRefreshTokenModal?: number,
  ) =>
  async (error: ResponseOrError, callback?: () => void) => {
    if (error instanceof Response) {
      const res = await getErrorJson(error);
      const onCloseCallback = () =>
        dispatch(ConnectedPageCRUDActions.retrieveAvailablePages());
      const requiredPermissions =
        res && res.required_permissions
          ? res.required_permissions
          : ALL_PERMISSIONS;

      switch (error.status) {
        case 403:
          dispatch(
            modalActions.openGrantPermissionsModal(
              requiredPermissions,
              onCloseCallback,
            ),
          );
          dispatch(ConnectedPageCRUDActions.unbusy());
          break;
        case 406:
          dispatch(unbusyAll());
          dispatch({
            type: ConnectedPageCRUDActions.setPermission,
            hasPermission: false,
          });
          break;
        case 422:
          dispatch(openConnectedPageErrorModal({ ...errorData(res) }));
          dispatch(ConnectedPageCRUDActions.unbusy());
          break;
        case errorStatusCodeToOpenRefreshTokenModal:
        case 400:
          dispatch(
            openRefreshAccessTokenErrorModal({
              error: res.errors[0],
              callback,
            }),
          );
          dispatch(ConnectedPageCRUDActions.unbusy());
          break;
        default:
          await commonHandler(dispatch)(error);
      }
    } else {
      await commonHandler(dispatch)(error);
    }
  };
